<template>
    <v-dialog v-model="shows" max-width="880">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card>
            <v-card-title>
                출석상세 <v-spacer /> <v-btn text icon tile @click="shows = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-divider />
            <v-data-table v-bind="{ items, headers }" hide-default-footer disable-filtering disable-sort disable-pagination :items-per-page="-1">
                <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" v-slot:[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>
                <template #[`item.attendance`]="{ item }">
                    <v-row no-gutters justify="center">
                        <v-col cols="auto">
                            <v-switch v-model="item.hasUserAttended" v-bind="attrs_switch" class="ml-1 mr-n1" style="width: 48px" @change="toggleAttendance(item)" />
                        </v-col>
                    </v-row>
                </template>
            </v-data-table>
        </v-card>
    </v-dialog>
</template>

<script>
import { attrs_switch } from "@/assets/variables";

let headers = [
    { width: 110, divider: true, text: "아이디", value: "user.username" },
    { width: 110, divider: true, text: "이름", value: "applicant.name" },
    { width: 150, divider: true, text: "학교/학과/과정", value: "applicantAffiliation", cellClass: "white-space-pre-line caption" },
    { width: 120, divider: true, text: "국가연구자번호", value: "applicant.researcherNo" },
    { width: 110, divider: true, text: "생년월일", value: "applicant.bornAt", formatter: (value) => (value ? value?.toDate?.() || value || "-" : value || "-") },
    { width: 140, divider: true, text: "연락처", value: "applicantContactInfo", cellClass: "white-space-pre-line caption" },
    { width: 120, align: "center", text: "출석", value: "attendance" },
];

export default {
    props: {
        unit: { type: Object, default: () => ({}) },
        attendances: { type: Array, default: () => [] },
        applications: { type: Array, default: () => [] },
    },
    data() {
        return {
            shows: false,
            headers,
            attrs_switch,
        };
    },
    computed: {
        items() {
            return this.applications.map((application = {}) => {
                let attendance = (this.attendances || []).find(({ _user }) => _user == application._user);
                let hasUserAttended = !!attendance;

                let { affiliation, department, courseName, phone, email } = application.applicant || {};
                let applicantAffiliation = `${affiliation || "-"}\n${department || "-"} / ${courseName || "-"}`;
                let applicantContactInfo = `${phone || "-"}\n${email || "-"}`;

                return {
                    ...application,
                    attendance,
                    hasUserAttended,
                    applicantAffiliation,
                    applicantContactInfo,
                };
            });
        },
    },
    methods: {
        async toggleAttendance(item) {
            if (item?.attendance) this.$emit("removeAttendance", item?.attendance);
            else {
                let { _program, _id: _unit } = this.unit;
                let { _user } = item;
                this.$emit("postAttendance", { _program, _unit, _user });
            }
        },
    },
};
</script>
